<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title" v-if="Tversion==3">{{$t('福利专区')}}</div>
            <div class="title" v-else>{{$t('langNew4.flhd')}}</div>
        </div>
        <div class="cotainer benefits">
          <div class="benefits-head">
            <template v-if="Tversion==3">
              <div class="t1">{{$t('福利专区')}}</div>
              <div class="t2">{{$t('请时刻关注福利活动，我们将不定期发布')}}</div>
            </template>
            <template v-else>
              <div class="t1">{{$t('langNew4.flzx')}}</div>
              <div class="t2">{{$t('langNew4.lqjl')}}<span class="money">$5000</span></div>
            </template>
            <!-- <div class="t3">{{$t('langNew4.wyzq')}}0.00 USDT</div> -->
          </div>
          <div class="benefits-tips">{{$t('langNew4.hdlb')}}</div>
          <ul class="ul">
            <!-- <li class="li" @click="jump(item)" v-for="(item,index) in flData" :key="index">
              <div class="banner-box"><img class="banner" :src="item.url" alt=""></div>
              <div class="title">{{item.title}}</div>
              <div class="status">{{$t('langNew2.jxz')}}</div>
            </li> -->
            <li class="li" @click="jump(item)" v-for="(item,index) in flData">
              <div class="t1">{{item.bonus}}</div>
              <div class="title">{{item.title}}</div>
              <div class="t2">{{item.content}}</div>
              <div class="btn">{{$t('langNew4.qwc')}}</div>
            </li>
            <!-- <li class="li" @click="jump">
              <div class="banner-box"><img class="banner" src="@/assets/flzq/banner3.jpg" alt=""></div>
              <div class="title">Swap free Crypto & Gold</div>
              <div class="status">{{$t('langNew2.jxz')}}</div>
            </li> -->
          </ul>
            <!-- 返回顶部 -->
            <img id="goTop" v-if="theme" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/theme/goTop_white.png" alt="">
            <img id="goTop" v-else class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/goTop.png" alt="">
            <!-- 暂无数据 -->
            <div class="null-box" v-show="isNoData">
              <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
              <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
              <p class="text">{{$t('zwsj.title')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'benefits',
    data () {
        return {
          theme: false,
          flData: [],
          isNoData: false,
          isGoTOP: false,
          curDataLength: 10,
          page: 1
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      if(this.Tversion == 3){
        this.getRule();
      }
    },
    mounted() {
      this.getFuli()
    },
    methods: {
      back(){
          this.$router.go(-1)
      },
      jump(item){
        var id = item.id;
        if(this.filterHtmlTag(item.content)){
          this.$router.push({path: "/benefitsDetail",query: { id }});
        }
      },
      getFuli(){
		  	let params = {
          token:1,
          page: this.page
        }
        this.$ajax.get('/web/getFuli',{params}).then((res) => {
          let resData = res.data.data;
          if(resData.length > 0){
            this.flData = this.flData.concat(resData);
            this.curDataLength = resData.length;
          }else{
            this.curDataLength = resData.length;
          }
          if(this.flData.length > 0){
            this.isNoData = false;
          }else{
            this.isNoData = true;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getRule(){
        let params = {
            type:'about'
        }
         this.$ajax.get('/web/getTextsList',{params}).then((res) => {
             let resData = res.data.data;
             this.title = resData.title;
             this.cont = this.contHtml(resData.content);
         }).catch(function(err){
             console.log(err)
         });
      },
      listenScroll(e) {  //监听滚动
        let ele = e.srcElement ? e.srcElement : e.target;
        if(ele.scrollTop > 200){
            this.isGoTOP = true
        }else{
            this.isGoTOP = false
        }
        if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
            if(this.curDataLength > 0){
                this.page ++;
                this.getFuli();
            }
        }
      },
      goTop(){
        $('.cotainer').animate({scrollTop:'0px'},'slow');
      },
      filterHtmlTag(msg){
        var msg = msg.replace(/<\/?[^>]*>/g, ''); //去除HTML Tag
          msg = msg.replace(/[|]*\n/, '') //去除行尾空格
          msg = msg.replace(/&nbsp;/ig, ''); //去掉nbsp
          return msg;
      },
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
      position: absolute;
      left: 0;
      right: 0;
      top: 1.6rem;
      bottom: 0;
      background: #f9f9f9;
      overflow-y: scroll;
    }
    .cotainer .ul{
      margin: 0 .52rem;
    }
    .cotainer .li{
      margin: 0 0 .8rem 0;
      padding-bottom: .5rem;
      background: #fff;
      box-shadow: 0px 23px 68px 0px
      		rgba(0, 0, 0, 0.14);
      border-radius: .2rem;
    }
    .cotainer .banner{
      width: 100%;
      height: 4.06rem;
      background: #fff;
	    border-radius: 0.42rem .42rem 0 0;
    }
    .cotainer .title{
      padding: .36rem .65rem .78rem;
      color: #000;
      font-size: .5rem;
    }
    .cotainer .status{
      height: 1.1rem;
      margin: 0 .78rem;
      color: #000;
      font-size: .46rem;
      line-height: 1.1rem;
      background: #fff;
	    border-radius: 0.54rem;
      text-align: center;
    }
    .benefits-head{
      height: 6.2rem;
      padding: 0 .42rem .42rem;
      background: url(../assets/new4/sucai2.png) no-repeat center center;
      background-size: cover;
      box-sizing: border-box;
    }
    .benefits-head .t1{
      padding: 1.5rem 0 1.3rem;
      color: #000;
      font-size: .7rem;
    }
    .benefits-head .t2{
      color: #fff;
      font-size: .46rem;
    }
    .benefits-head .money{
      color: #17ad53;
    }
    .benefits-head .t3{
      margin-top: .8rem;
      color: #fff;
      font-size: .46rem;
    }
    .benefits-tips{
      padding: .84rem .54rem .8rem;
      color: #000;
      font-size: .56rem;
    }
    .benefits .li{
      padding: .7rem .6rem .78rem;
      background: #fff!important;
	    border-radius: 0.42rem;
    }
    .benefits .t1{
      color: #fff;
      font-size: .7rem;
    }
    .benefits .title{
      padding: .7rem 0 .5rem;
      color: #fff;
      font-size: .56rem;
    }
    .benefits .t2{
      color: #7d7d7d;
      font-size: .4rem;
    }
    .benefits .btn{
      height: 1.08rem;
      margin-top: .8rem;
      color: #fff;
      font-size: .46rem;
      line-height: 1.08rem;
      background: #000;
      border-radius: 0.55rem;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/benefits.vue